import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-workspace',
  templateUrl: './workspace.component.html',
  styleUrl: './workspace.component.scss'
})
export class ConfigurationWorkspaceComponent {

  configMenuItems: MenuItem[] = [];
  displayCreateUpdateCommentCategory: boolean = false;
  isEditMode: boolean = false;
  selectedCategory: any;
  reloadCategory: boolean = false;

  constructor() { }

  ngOnInit() {
    this.setMenuItems();
  }

  setMenuItems(): void {
    this.configMenuItems = [
      {
        label: 'Add Category',
        icon: 'pi pi-plus',
        command: () => {
          this.addCategory();
        }
      }    ];
  }
  addCategory(): void {
    this.reloadCategory = false;
    this.displayCreateUpdateCommentCategory = true;
    this.isEditMode = false;
  }

  hideCreateUpdateCategory(event: any): void {
    this.displayCreateUpdateCommentCategory = event.displayCreateUpdateCommentCategory;
    this.isEditMode = false;
  }

  refreshCategory(event: any): void {
    this.reloadCategory = true;
  }
}
